
<script>
export default {
  props: {
    // version: String,
    score: Number,
    EndTrain: Boolean,
    porp: Object,
    iconSize: Number
  },
  data() {
    let starList = [
      "./assets/star-blank.svg",
      "./assets/star-blank.svg",
      "./assets/star-blank.svg"
    ];
    if (this.score && this.score > 0) {
      let redStar = Math.floor(this.score / 2);
      let yellowStar = this.score % 2 === 0 ? false : true;
      let i = 0;
      if (redStar > 0) {
        for (; i < redStar; i++) {
          starList[i] = "./assets/star-red.svg";
        }
      }
      if (yellowStar) {
        starList[i] = "./assets/star-yellow.svg";
      }
    }
    return {
      clickTimes: 0,
      showBonusScene: false,
      starList
      //   tabTitle: this.platform
    };
  },
  computed: {
    style() {
      const size = this.iconSize || 12.5;
      return {
        width: `${size}px`,
        height: `${size}px`
      };
    }
  }
  //   methods: {

  //   }
};
</script>

<template>
  <div class="starContent">
    <img class="star" :style="style" :src="starList[0]" />
    <img class="star" :style="style" :src="starList[1]" />
    <img class="star" :style="style" :src="starList[2]" />
  </div>
</template>

<style lang="scss">
.starContent {
  min-height: 15px;

  .star {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin: 5px 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/trainStar.vue